export default {
    'commercial-invoices': 'الفواتير التجارية',
    'the-commercial-invoice': 'الفاتورة التجارية؟',
    'add-a-commercial-invoice': 'إضافة فاتورة تجارية',
    'commercial-invoice': 'فاتورة تجارية',
}